/**
 * 알림为空状态组件
 */
import { EmptyIcon } from './Icons';
import type { NotificationTranslations } from './constants';

interface EmptyStateProps {
  t: NotificationTranslations;
}

export function EmptyState({ t }: EmptyStateProps) {
  return (
    <div className="p-8 text-center">
      <EmptyIcon />
      <p className="text-muted-foreground">
        {t.noNotifications}
      </p>
    </div>
  );
}
